import { render } from "./PlanosPagamento.vue?vue&type=template&id=40276e0c&scoped=true"
import script from "./PlanosPagamento.vue?vue&type=script&lang=js"
export * from "./PlanosPagamento.vue?vue&type=script&lang=js"

import "./PlanosPagamento.vue?vue&type=style&index=0&id=40276e0c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40276e0c"]])

export default __exports__